import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function Specialized() {
  return (
    <>
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/DNA.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown">Specialized Services</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                Specialized Services
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ScrollSection>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="mb-4">Specialized Services</h2>
              <p>
                Our Specialized Services department offers advanced medical care for complex conditions. Our team of
                specialists provides expert diagnosis and treatment across various medical disciplines.
              </p>
            </div>
          </div>
        </div>
      </ScrollSection>
    </>
  );
}

export default Specialized;
